import React from 'react';

const DeleteCircleBtn = props => (
	<svg viewBox="0 0 12 12" width="1em" height="1em" fill="#9B9B9B" fillRule="evenodd" {...props}>
		<path d="M11.528 3.665a5.978 5.978 0 0 0-1.286-1.908A5.98 5.98 0 0 0 6 0a5.969 5.969 0 0 0-4.243 1.757A5.977 5.977 0 0 0 0 6a5.978 5.978 0 0 0 1.757 4.243A5.986 5.986 0 0 0 6 12a5.968 5.968 0 0 0 4.243-1.757A5.977 5.977 0 0 0 12 6a5.96 5.96 0 0 0-.472-2.335zM9.396 8.239c.029.03.029.076 0 .106l-1.051 1.05a.075.075 0 0 1-.105 0L6 7.157l-2.24 2.24a.074.074 0 0 1-.105 0L2.604 8.345a.074.074 0 0 1 0-.106L4.844 6 2.604 3.76a.074.074 0 0 1 0-.105l1.052-1.05c.029-.03.076-.03.105 0l2.24 2.239 2.239-2.24c.029-.03.076-.03.105 0l1.05 1.051a.074.074 0 0 1 0 .105L7.157 6l2.24 2.24z" />
	</svg>
);

export default DeleteCircleBtn;
